import React, { useState } from 'react';

function CopyToClipBoard({ textToCopy, saveFileName }) {
  const [copied, setCopied] = useState(false);
  const [textToSave, setTextToSave] = useState(textToCopy);
  const fileName = saveFileName + Math.floor(new Date().getTime() / 1000) + ".txt";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  const handleDownload = () => {
    // Create a Blob object from the text content
    const blob = new Blob([textToSave], { type: 'text/plain' });

    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName; // Set the desired file name

    // Programmatically click the link to trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up: remove the link and revoke the object URL
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <div className="mt-4">
        <button className="edu-btn btn-bg-alt btn-small lh-1" onClick={handleCopy}>
          {copied ? 'Copied!' : 'Copy to Clipboard'}
        </button>
        <button className="edu-btn btn-bg-alt ms-4 btn-small lh-1" onClick={handleDownload}>
          Save Text as File
        </button>
      </div>
    </>
  );
}

export default CopyToClipBoard;